module.exports = __webpack_public_path__ + "static/media/shoulders-quizz.9a38065b.jpg";